import axios from 'api/axios'
import { ClientProfile } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface for the Response object you get from toggleClientStatus request if successful
 */
export interface ToggleClientStatusResponse {
	clientProflie: ClientProfile
}

/**
 * API call for toggle active status of client
 * @param id - id of client to be send to backend for toggle active status of client
 * @returns AdminResponse - Response object returned from the server
 */

export const toggleClientStatus = async (id: string) => {
	try {
		const { data } = await axios.patch<ToggleClientStatusResponse>(`client/${id}`)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default toggleClientStatus
